<div class="stock-page" @fadeInAnimation>
  <div class="stock-page-title">
    <span class="title" [innerHTML]="'REPORT.TITLE' | translate"></span>
  </div>

  <mat-tab-group [selectedIndex]="selectedTab">
    <mat-tab [label]="'REPORT.TABS.POWER_BI' | translate">
      <app-power-bi-page [powerBIConfig]="stock.powerBIConfig"></app-power-bi-page>
    </mat-tab>
    <mat-tab [label]="'REPORT.TABS.STOCK' | translate">
      <app-stock-page
        [authorization]="authorization"
        [isLoading]="isLoading"
        [items]="stock.items"
        [location]="location"
        [locations]="locations"
        [totalItems]="totalItems"
        (filterStock)="filterStock($event)"
      ></app-stock-page>
    </mat-tab>
  </mat-tab-group>
</div>
